import React, { useState, useEffect } from "react";
import { Box, FormHelperText, InputLabel , styled } from "@mui/material";
import UIRadioButton from "@/components/ui-controls/radio-button";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const RadioButtonGroup = (props) => {
  const {
    title,
    name,
    value = null,
    options,
    disabled,
    error,
    tooltip = "",
    onChange = () => { },
  } = props;

  const [selected, setSelected] = useState(null);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  const handleOnChange = (option) => {
    setSelected(option.id);
    onChange({ value: option.id });
  };

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          border: "1px solid rgba(0, 0, 0, 0.23)",
          borderRadius: 1,
          padding: "6px 14px",
          minHeight: "53.13px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <InputLabel
          id={`${name}-radio-group-label`}
          sx={{
            color: "var(--base-100)",
            background: "#FFF",
            px: 1,
            position: 'absolute',
            zIndex: 1,
            top: "-10px",
            fontSize: "0.656rem",
            left: "8px",
          }}
        >
          {title}
        </InputLabel>
        {/* <Typography variant="body1" sx={{ color: "var(--base-100)" }}></Typography> */}
        <Box className="custom-scroll" sx={{ overflow: "auto", height: "39.13px", padding: "7px 0", width: "calc(100% - 24px)" }}>
          {options?.map((option) => (
            <UIRadioButton
              key={option.id}
              name={name}
              checked={selected === option.id}
              handleChange={() => handleOnChange(option)}
              label={option.label}
              style={{ p: 0 }}
              parentStyle={{ mr: 3 }}
              disabled={disabled}
            />
          ))}
        </Box>
        {tooltip && <CustomWidthTooltip title={tooltip} placement="top-end">
          <InfoOutlined color="action" sx={{ fontSize: 18, position: 'relative', right: "-7px", cursor: "text"}} />
        </CustomWidthTooltip>}
        {error && (
          <FormHelperText sx={{ position: "absolute", bottom: "-20px" }}>
            {error}
          </FormHelperText>
        )}
      </Box>
    </>
  );
};
const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 200,
  },
});
export default RadioButtonGroup;
